import { defineComponent as s, computed as l, openBlock as t, createElementBlock as f, createElementVNode as e, toDisplayString as d, createCommentVNode as n, normalizeStyle as h, createStaticVNode as x } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "35044651-0b66-43d4-80d9-af0944f8431f" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), y = { mask: "url(#35044651-0b66-43d4-80d9-af0944f8431f)" }, p = { key: 0 }, k = /* @__PURE__ */ x('<path fill="#d80027" d="M0 0h512v512H0z"></path><circle cx="256" cy="64" r="32" fill="#ffda44"></circle><circle cx="64" cy="256" r="32" fill="#ffda44"></circle><circle cx="448" cy="256" r="32" fill="#ffda44"></circle><circle cx="256" cy="448" r="32" fill="#ffda44"></circle><circle cx="352" cy="400" r="32" fill="#ffda44"></circle><circle cx="400" cy="352" r="32" fill="#ffda44"></circle><circle cx="352" cy="112" r="32" fill="#ffda44"></circle><circle cx="400" cy="160" r="32" fill="#ffda44"></circle><circle cx="160" cy="112" r="32" fill="#ffda44"></circle><circle cx="112" cy="160" r="32" fill="#ffda44"></circle><circle cx="112" cy="352" r="32" fill="#ffda44"></circle><circle cx="160" cy="400" r="32" fill="#ffda44"></circle><path fill="#ffda44" d="m256 60-103 52 20 61-61-20-52 103 52 103 61-20-20 61 103 52 103-52-20-61 61 20 52-103-52-103-61 20 20-61zm0 36 64 32-32 96 96-32 32 64-32 64-96-32 32 96-64 32-64-32 32-96-96 32-32-64 32-64 96 32-32-96z"></path>', 14), u = { fill: "none" }, g = ["r"], W = /* @__PURE__ */ s({
  __name: "occitania",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(o) {
    const c = o, i = l(() => 512 + 2 * c.strokeWidth), r = l(() => -c.strokeWidth), a = l(() => 256 + c.strokeWidth / 2);
    return (v, w) => (t(), f("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${r.value} ${r.value} ${i.value} ${i.value}`
    }, [
      m,
      e("g", y, [
        c.flagName ? (t(), f("title", p, d(c.flagName), 1)) : n("", !0),
        k
      ]),
      e("g", u, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: c.strokeColor, strokeWidth: c.strokeWidth })
        }, null, 12, g)
      ])
    ], 8, _));
  }
});
export {
  W as default
};
//# sourceMappingURL=occitania-392df43c.js.map
